import { FontWeights, getTheme, IconButton, mergeStyleSets, Modal, Stack, Text } from "@fluentui/react"
import { ConfirmationForm } from "./forms/ConfirmationForm";
import { strings } from "../../localization/strings";

type TConfirmationProps = {
    onDismiss: () => void   // cancel deletion
    onConfirm: () => void   //  deletion approved.
    confirmPhrase: string   //  User must enter this text to confirm
}

export const ConfirmProductDeactivation : React.FC<TConfirmationProps> = (props) => {
    return (<DeleteConfirmationBase 
        onDismiss={props.onDismiss}
        onConfirm={props.onConfirm}
        confirmPhrase={props.confirmPhrase}
        title={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.TITLE}
        requiredMessage={strings.ORGANIZATION.CATALOGS.CATALOG.FIELDS.NAME_REQUIRED}
        text1={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.CONFIRMATION_TEXT1}
        text2={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.DESCRIPTION}
        confirmationPrompt={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.CONFIRMATION_PROMPT}
        placeholder={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.CONFIRMATION_PLACEHOLDER}
        buttonText={strings.BUTTONS.TEXT.DEACTIVATE}
        />
    )
}

export const ConfirmProductActivation : React.FC<TConfirmationProps> = (props) => {
    return (<DeleteConfirmationBase 
        onDismiss={props.onDismiss}
        onConfirm={props.onConfirm}
        confirmPhrase={props.confirmPhrase}
        title={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.ACTIVATE_ORGANIZATION.TITLE}
        requiredMessage={strings.ORGANIZATION.CATALOGS.CATALOG.FIELDS.NAME_REQUIRED}
        text1={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.ACTIVATE_ORGANIZATION.CONFIRMATION_TEXT1}
        text2=""
        confirmationPrompt={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.ACTIVATE_ORGANIZATION.CONFIRMATION_PROMPT}
        placeholder={strings.ORGANIZATION.SETTINGS.GENERAL.OVERVIEW.DEACTIVATE_ORGANIZATION.CONFIRMATION_PLACEHOLDER}
        buttonText={strings.BUTTONS.TEXT.ACTIVATE}
        />
    )
}

type TDeleteConfirmationProps = {
    onDismiss: () => void   // cancel deletion
    onConfirm: () => void   //  deletion approved.
    confirmPhrase: string   //  User must enter this text to confirm
    title: string               //  Main title
    requiredMessage: string     //  Input validation error
    placeholder: string         //  Input placeholder
    buttonText: string          //  "confirm" button text
    text1: string               //  1st part of confirmation message
    text2: string               //  2nd part of confirmation message
    confirmationPrompt: string  //  3rd part of confirmatin mesage. joined with confirm phrase.
}

export const DeleteConfirmationBase : React.FC<TDeleteConfirmationProps> = (props) => {

    return (
        <Modal isOpen={true} onDismiss={props.onDismiss} containerClassName={DeleteConfirmation_contentStyles.container}>
            <div className={DeleteConfirmation_contentStyles.header}>
                <span style={{ paddingRight: 32 }}>{props.title}</span>
                <IconButton
                    styles={DeleteConfirmation_iconButtonStyles}
                    iconProps={{ iconName: "Cancel" }}
                    ariaLabel="Close"
                    onClick={props.onDismiss}
                />
            </div>
            <div className={DeleteConfirmation_contentStyles.body}>
                <ConfirmationForm
                    onConfirm={props.onConfirm}
                    onCancel={props.onDismiss}
                    requiredMessageString={props.requiredMessage}
                    confirmationCheckString={props.confirmPhrase}
                    placeholder={props.placeholder}
                    confirmText={props.buttonText}
                >
                    <Stack tokens={{ childrenGap: 12 }}>
                        <Text>{props.text1}</Text>
                        <Text>{props.text2}</Text>
                        <Text>{props.confirmationPrompt} <b>"{props.confirmPhrase}"</b></Text>
                    </Stack>
                </ConfirmationForm>
            </div>
        </Modal>
    )
}

const theme = getTheme();

export const DeleteConfirmation_contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
        width: 480,
        borderRadius: 6
    },
    header: [
        theme.fonts.large,
        {
            flex: '1 1 auto',
            color: theme.palette.neutralPrimary,
            display: 'flex',
            alignItems: 'center',
            fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],
    body: {
        position: "relative",
        flex: '4 4 auto',
        padding: '0px 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: { margin: '14px 0' },
            'p:first-child': { marginTop: 0 },
            'p:last-child': { marginBottom: 0 },
        },
    },
});

export const DeleteConfirmation_iconButtonStyles = {
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    },
    rootHovered: {
        color: theme.palette.neutralDark,
    },
};
